import React, { useRef, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Dial } from './Dial';
import { twelve } from '../data/twelve';
export function MeaningDial() {
  const [active, setActive] = useState(11);
  const [rotation, setRotation] = useState(360);
  const btnRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const reduce = useReducedMotion();
  const item = twelve[active];
  function select(i: number, focus = false) {
    const target = twelve[i].n * 30 % 360;
    setRotation(prev => {
      const cur = (prev % 360 + 360) % 360;
      let d = target - cur;
      if (d > 180) d -= 360;
      if (d < -180) d += 360;
      return prev + d;
    });
    setActive(i);
    if (focus) btnRefs.current[i]?.focus();
  }
  function onKeyDown(e: React.KeyboardEvent, i: number) {
    const map: Record<string, number> = {
      ArrowRight: (i + 1) % 12,
      ArrowDown: (i + 1) % 12,
      ArrowLeft: (i + 11) % 12,
      ArrowUp: (i + 11) % 12,
      Home: 0,
      End: 11
    };
    if (e.key in map) {
      e.preventDefault();
      select(map[e.key], true);
    }
  }
  return <div className="grid items-center gap-[clamp(3rem,6vw,9rem)] lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-292" data-mp="d9804u1g59u3">
      <div className="relative mx-auto aspect-square w-full max-w-[min(100%,44rem)] lg:max-w-[min(100%,82vh)]" data-id="element-293" data-mp="94rxd1n4qij3">
        <Dial hands={false} numerals={false} className="absolute inset-0 h-full w-full" data-id="element-294" data-mp="49cl2e4rsuos" />
        <motion.div aria-hidden="true" className="absolute inset-0" initial={false} animate={{
        rotate: rotation
      }} transition={reduce ? {
        duration: 0
      } : {
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-295" data-mp="3veuhpfyani15">
          <span className="absolute left-1/2 top-[20%] h-[30%] w-px -translate-x-1/2 bg-charcoal" data-id="element-296" data-mp="3hmxthmzqxsa1" />
        </motion.div>
        <span aria-hidden="true" className="absolute left-1/2 top-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gold" data-id="element-297" data-mp="3clqlpnxlst3d" />

        <div role="radiogroup" aria-label="The twelve: choose an index" data-id="element-298" data-mp="37qb8my7f7180">
          {twelve.map((t, i) => {
          const a = t.n * 30 * Math.PI / 180;
          const left = 50 + 37 * Math.sin(a);
          const top = 50 - 37 * Math.cos(a);
          const on = i === active;
          return <button key={t.n} ref={el => {
            btnRefs.current[i] = el;
          }} type="button" role="radio" aria-checked={on} tabIndex={on ? 0 : -1} aria-label={`${t.numeral}: ${t.sign}, ${t.house}, ${t.month}`} onClick={() => select(i)} onKeyDown={e => onKeyDown(e, i)} style={{
            left: `${left}%`,
            top: `${top}%`
          }} className={`group absolute grid h-[clamp(2.6rem,4.4vw,4.25rem)] w-[clamp(2.6rem,4.4vw,4.25rem)] -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full transition-colors duration-150 ${on ? 'bg-charcoal text-white' : 'bg-white/0 text-charcoal hover:bg-cream'}`} data-id="element-299" data-mp="2t19y735tvdy2" data-mpi={i}>
                <span className="t-numeral text-[clamp(0.85rem,0.7rem+0.4vw,1.15rem)]" data-id="element-300" data-mp="1o1k2lfvvpwei">{t.numeral}</span>
                <span className="t-label pointer-events-none absolute left-1/2 top-full mt-1 -translate-x-1/2 whitespace-nowrap bg-white px-2 py-0.5 text-[0.58rem] text-charcoal opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100 [@media(hover:none)]:hidden" data-id="element-301" data-mp="22qpxwsrlj2h4">
                  {t.sign}
                </span>
              </button>;
        })}
        </div>
      </div>

      <div aria-live="polite" data-id="element-302" data-mp="1j0xdruv1ax00">
        <p className="t-label text-gold-deep" data-id="element-303" data-mp="1f15fcazcu78d">
          <span className="t-numeral" data-id="element-304" data-mp="1f0dgmragntdv">{item.numeral}</span> · {item.n} o'clock
        </p>
        <p className="t-h2 mt-4" data-id="element-305" data-mp="2ugue0f8bp3cj">
          {item.sign} <span className="font-light text-graphite" data-id="element-306" data-mp="2qh3t2s5h9hfx">· {item.sanskrit}</span>
        </p>
        <dl className="mt-10 divide-y divide-stone border-y border-stone" data-id="element-307" data-mp="2qj6jhdajlcl6">
          {[['Hour', `${item.numeral} · ${item.n} o'clock`], ['Sign', `${item.sign} (${item.sanskrit})`], ['House', item.house], ['Month', item.month], ['Area of life', item.area]].map(([k, v]) => <div key={k} className="grid grid-cols-[8rem_minmax(0,1fr)] gap-4 py-4 sm:grid-cols-[11rem_minmax(0,1fr)]" data-id="element-308" data-mp="3m6sg9ob52zg">
              <dt className="t-label text-[0.66rem] text-graphite" data-id="element-309" data-mp="8k8biulqh2ax">{k}</dt>
              <dd className="text-charcoal" data-id="element-310" data-mp="cl0nvwpwjnbf">{v}</dd>
            </div>)}
        </dl>
        <p className="mt-6 text-sm text-graphite" data-id="element-311" data-mp="hdtoq9i92bi8">Select any index on the dial, or use the arrow keys.</p>
      </div>
    </div>;
}